import { Grid } from "@mui/material";
import CustomerAutomations from "./CustomerAutomations";
import OrderAutomations from "./OrderAutomations";

const AutomationConfig = () => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        marginTop: 1,
        marginBottom: 1,
        paddingLeft: 1,
        paddingRight: 1,
      }}
    >
      <Grid size={{ xs: 12, lg: 6 }} data-testid="orders">
        <OrderAutomations />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }} data-testid="customers">
        <CustomerAutomations />
      </Grid>
    </Grid>
  );
};

export default AutomationConfig;
